'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var processLogout = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2) {
    var auth = _ref2.auth,
        history = _ref2.history;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return auth.logout();

          case 3:
            history.push('/login');
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context['catch'](0);

            console.error('processLogout:', _context.t0);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 6]]);
  }));

  return function processLogout(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _Navbar = require('./Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var shape = _propTypes2.default.shape,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

var enhancer = (0, _compose2.default)((0, _setPropTypes2.default)({
  auth: shape({
    logout: func.isRequired
  }),
  history: shape({
    push: func.isRequired
  }),
  config: shape({
    ui: object.isRequired
  })
}), (0, _withHandlers2.default)({
  logout: function logout(props) {
    return function () {
      return processLogout(props);
    };
  },
  goPassword: function goPassword(_ref3) {
    var history = _ref3.history;
    return function () {
      return history.push('/password');
    };
  }
}), (0, _withProps2.default)(function (_ref4) {
  var ui = _ref4.config.ui;
  return { title: ui.navbar.title };
}));

exports.default = enhancer(_Navbar2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/Navbar/index.js
// module id = 1023
// module chunks = 0